export default __webpack_public_path__ + "static/media/Flus-around-the-horn.42a340dc.png";